export default __webpack_public_path__ + "static/media/shopify.f541f965.png";